import { Typography } from '@mui/material';

const LabeledValue = ({ label = '', children }) => {
  return (
    <>
      <Typography style={{ fontWeight: 'bold' }}>{label}: </Typography>
      <Typography component="span">{children}</Typography>
    </>
  );
};

export default LabeledValue;
